import { extractApiErrorCode } from '@react-apps/auth';

/**
 * O que o modal diz depois de dar acesso a uma plataforma — o mesmo mapa para o
 * admin e o iamEditor, na lista e no detalhe. Sai do **código** que o back
 * devolve, nunca do `error.message` cru: a mensagem do back é para log, em
 * inglês, e pode mudar sem aviso.
 */
export function accessGrantedMessage(profileCreated: boolean): string {
  // "Convite" com condição: o back só manda o e-mail de primeiro acesso para
  // quem ainda não definiu a senha; quem já definiu entra direto.
  return profileCreated
    ? 'Acesso criado. Se a pessoa ainda não definiu a senha, enviamos o convite por e-mail.'
    : 'A pessoa já tinha acesso a esta plataforma. Nada mudou.';
}

const ERROR_MESSAGES: Record<string, string> = {
  PLATFORM_ACCESS_INACTIVE:
    'O acesso desta pessoa está desativado; peça a um admin que o reative.',
  INSUFFICIENT_ACCOUNT_AUTHORITY:
    'Esta conta só pode ser operada por um admin.',
};

export const ACCESS_GRANT_GENERIC_ERROR =
  'Não foi possível concluir. Tente de novo.';

export function accessGrantErrorMessage(err: unknown): string {
  return (
    ERROR_MESSAGES[extractApiErrorCode(err) ?? ''] ?? ACCESS_GRANT_GENERIC_ERROR
  );
}

/**
 * `m***@dominio.com`: no detalhe o iamEditor confirma de quem é o acesso sem o
 * modal repetir o endereço inteiro.
 */
export function maskEmail(email: string): string {
  const at = email.indexOf('@');
  if (at < 1) return '***';
  return `${email[0]}***${email.slice(at)}`;
}
